import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { pageFadeIn } from "../../../utils/animations";
import NavBar from "../../../Components/Navbar/NavBar";
import Sales from "./SalesKT";
import Reports from "./ReportsKT";
import About from "./AboutKT";
import kt_logo from "../../../Assets/kantobar.png";

function KT() {
  const [selectedOption, setSelectedOption] = useState("Sales");

  const handleTabClick = (tab) => {
    setSelectedOption(tab);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case "Sales":
        return <Sales content="Sales KT" color="red" />;
      case "Reports":
        return <Reports content="Reports KT" />;
      case "About":
        return <About content="About KT" />;
      default:
        return <Sales content="Sales KT" color="red" />;
    }
  };

  return (
    <Box h="100vh" bg="gray.50" overflow="hidden">
      <NavBar
        tabIndicatorColor="red.600"
        logo={kt_logo}
        onTabClick={handleTabClick}
      />

      <Box
      w="100%"
      h="calc(100vh - 60px)"
      overflow="hidden"
      bgColor="white"
      bgImage={`linear-gradient(rgba(255,255,255,0.88), rgba(255,255,255,0.88)), url(${kt_logo})`}
      bgRepeat="no-repeat"
      bgSize="40% auto"
      bgPosition="right -80px"
      sx={{ animation: `${pageFadeIn} 0.55s ease both` }}
    >
        {renderContent()}
      </Box>
    </Box>
  );
}

export default KT;
